import * as DiscountTypes from '../types/discount';
import initialState from 'store/reducers/initialState';
import { updateObject } from 'utils';

const updateItemField = (state, payload, field) =>
  state[field].map(prev => {
    if (String(prev._id) === String(payload.updatedObject._id)) {
      return payload.updatedObject;
    }
    return prev;
  });

export const discount = (state = initialState.suppliers, action) => {
  switch (action.type) {
    case DiscountTypes.FETCH_DISCOUNT_CODE_SUCCESS:
      return updateObject(state, { ...action.payload, loading: false });

    case DiscountTypes.FETCH_DISCOUNT_CODE_FAILED:
      return updateObject(state, { error: action.error });

    case DiscountTypes.FETCH_DISCOUNT_CODE_START:
      return updateObject(state, { formErrorMessage: null, isSaving: true });

    case DiscountTypes.ADD_DISCOUNT_CODE_START:
      return updateObject(state, { ...action.payload, isSaving: true });

    case DiscountTypes.ADD_DISCOUNT_CODE_FAILED:
      return updateObject(state, {
        formErrorMessage: action.error,
        isSaving: false,
      });

    case DiscountTypes.ADD_DISCOUNT_CODE_SUCCESS:
      return updateObject(state, { ...action.payload, formErrorMessage: null });

    case DiscountTypes.UPDATE_DISCOUNT_CODE_START:
      return updateObject(state, {
        isSaving: true,
      });

    case DiscountTypes.UPDATE_DISCOUNT_CODE_FAILED:
      return updateObject(state, {
        isSaving: null,
      });

    case DiscountTypes.UPDATE_DISCOUNT_CODE_SUCCESS:
      return updateObject(state, {
        formErrorMessage: null,
        isSaving: false,
        items: updateItemField(state, action.payload, 'items'),
        filteredItems: updateItemField(state, action.payload, 'filteredItems'),
      });

    case DiscountTypes.UPDATE_DISCOUNT_CODE_LIST:
      return updateObject(state, { ...action.payload, isSaving: null });

    default:
      return { ...state };
  }
};
